// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-2-Cyymqa","breadcrumbs":"breadcrumbs-3K4SWxEh"};